import { Box, withStyles } from '@material-ui/core';
import { TextColor } from '@setvi/shared/enums';
import { ProductStatusEnum } from '../status';

export const productStatusStyle = {
  [ProductStatusEnum.Active]: {
    borderColor: '#AFBAC6',
    color: TextColor.SlateGrey
  },
  [ProductStatusEnum.Inactive]: {
    backgroundColor: '#EEF0F2',
    borderColor: '#EEF0F2',
    color: '#AFBAC6'
  },
  [ProductStatusEnum.Discontinued]: {
    borderColor: '#AFBAC6',
    color: TextColor.SlateGrey
  }
};

export const ProductStatusBadge = withStyles(theme => ({
  root: {
    minWidth: 50,
    padding: theme.spacing(1, 2),
    borderRadius: 16,
    border: '1px solid',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    borderColor: (props: any) => (props.disabled ? 'transparent' : '#AFBAC6'),
    backgroundColor: (props: any) =>
      props.disabled ? '#EEF0F2' : 'transparent',
    color: (props: any) => (props.disabled ? '#AFBAC6' : TextColor.SlateGrey),

    '& p': {
      fontWeight: 700,
      fontSize: 11,
      color: (props: any) => (props.disabled ? '#AFBAC6' : TextColor.SlateGrey)
    }
  }
}))(Box);
